import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppDefaultComponent} from './app-default.component';
import {SharedModule} from '../../../shared/shared.module';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../../guards/auth.guard';

const ROUTES: Routes = [
  {
    path: '',
    component: AppDefaultComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'dashboard', loadChildren: () => import('../../../modules/dashboard/dashboard.module').then(m => m.DashboardModule)},
      {path: 'impersonate', loadChildren: () => import('../../../modules/impersonate/impersonate.module').then(m => m.ImpersonateModule)},
      {path: 'tools', loadChildren: () => import('../../../modules/tools/tools.module').then(m => m.ToolsModule)},
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {path: '', loadChildren: () => import('../../../modules/viewings/viewings.module').then(m => m.ViewingsModule)},
      {path: '', loadChildren: () => import('../../../modules/user/user.module').then(m => m.UserModule)},
      {path: '', loadChildren: () => import('../../../modules/referrals/referrals.module').then(m => m.ReferralsModule)},
      {path: '', loadChildren: () => import('../../../modules/property/property.module').then(m => m.PropertyModule)},
      {path: 'calendar', loadChildren: () => import('../../../modules/calendar/calendar.module').then(m => m.CalendarModule)},
      {path: 'properties', loadChildren: () => import('../../../modules/properties/properties.module').then(m => m.PropertiesModule)},
      {
        path: 'league-table',
        loadChildren: () => import('../../../modules/league-tables/league-tables.module').then(m => m.LeagueTablesModule)
      },
      {path: '', loadChildren: () => import('../../../modules/approvals/approvals.module').then(m => m.ApprovalsModule)},
      {
        path: '',
        loadChildren: () => import('../../../modules/buyers-approvals/buyers-approvals.module').then(m => m.BuyersApprovalsModule)
      },
      {path: '', loadChildren: () => import('../../../modules/mos/mos.modules').then(m => m.MosModules)},
      {path: 'buyers', loadChildren: () => import('../../../modules/buyers/buyers.module').then(m => m.BuyersModule)},
      {
        path: 'valuation-report',
        loadChildren: () => import('../../../modules/valuation-report/valuation-report.module').then(m => m.ValuationReportModule)
      },
      {
        path: 'associates',
        loadChildren: () => import('../../../modules/associates/associates.module').then(m => m.AssociatesModule)
      },
      {
        path: 'foreign-travel',
        loadComponent: () => import('./../../../shared/components/foreign-travel/foreign-travel.component').then(mod => mod.ForeignTravelComponent),
      }
    ]
  },
  {
    path: 'guest',
    loadChildren: () => import('../../../modules/guest/guest.module').then(m => m.GuestModule)
  }
];

@NgModule({
  declarations: [AppDefaultComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ROUTES)
  ],
  exports: [
    RouterModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppDefaultRoutingModule {
}
